import { render, staticRenderFns } from "./EditCustomerService.vue?vue&type=template&id=4e524f8c&scoped=true&"
import script from "./EditCustomerService.vue?vue&type=script&lang=js&"
export * from "./EditCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerService.vue?vue&type=style&index=0&id=4e524f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e524f8c",
  null
  
)

export default component.exports